// src/features/catalogue/overrides/index.js
export async function loadOverridesForCategory(category) {
  switch (category) {
    case "Bed Frames":
      return (await import("./beds.js")).default;
    case "Chest Drawers":
      return (await import("./drawers.js")).default;
    case "Shoe Cabinets":
      return (await import("./shoescabinet.js")).default;
    case "Side Table":
      return (await import("./sidetable.js")).default;
    case "Sideboards":
      return (await import("./sideboards.js")).default;
    case "Wardrobes":
      return (await import("./wardrobes.js")).default;
    default:
      return {};
  }
}
